class ShapeSelectorComponent extends HTMLElement {

  constructor() {
    super();
    //this.shapeType = 'custom-shape'
    
    //document.addEventListener('custom-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    

    <!-- Modal shape selector -->
    <div class="modal fade" id="modal-shape-selector-dialog" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog shapes-selector-dialog">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <button type="button" class="dialog-close" data-dismiss="modal" aria-label="Close"><span
                  aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="myModalLabel">Select a Shape</h4>
            </div>
            <div class="modal-body modal-body-shadow" style="background:#F8F8F8">
              <!-- Top row shape (category) buttons -->
              <div class="text-center">
                <a type="button" class="btn btn-primary button-shadow" id="north-american-shapes-button"
                  href="#north-american-shapes" data-toggle="tab" onclick="onNorthAmericanSteelClick()">
                  North American Steel</a>
                <a type="button" class="btn btn-default button-shadow" id="european-shapes-button" 
                  href="#european-shapes" data-toggle="tab" onclick="onEuropeanSteelClick()">
                  European Steel</a>
                <a type="button" class="btn btn-default button-shadow" id="wood-shapes-button" 
                  href="#wood-shapes" data-toggle="tab" onclick="onWoodShapesClick()">
                  Wood</a>
                <a type="button" class="btn btn-default button-shadow" id="custom-shapes-button" 
                  href="#custom-shapes" data-toggle="tab" onclick="onCustomShapesClick()">
                  Custom Shapes</a>
              </div>
            </div>

            <div class="modal-body">

              <div class="bs-component tab-content text-center">
                <!-- North American Shapes -->
                <div class="tab-pane fade in active" id="north-american-shapes" style="margin-bottom:10px;">
                  <north-american-steel-shape-selector-component></north-american-steel-shape-selector-component>
                </div>

                <!-- European Shapes -->
                <div class="tab-pane fade in" id="european-shapes" style="margin-bottom:10px;">
                  <european-steel-shape-selector-component></european-steel-shape-selector-component>
                </div>

                <!-- Wood Shapes -->
                <div class="tab-pane fade in" id="wood-shapes" style="margin-bottom:10px;">
                  <wood-shape-selector-component></wood-shape-selector-component>
                </div>

                <!-- Custom Shapes -->
                <div class="tab-pane fade in" id="custom-shapes" style="margin-bottom:10px;">
                  <custom-shape-selector-component></custom-shape-selector-component>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="panel-body shapes-selector-body">
                  <!-- Table -->
                  <div id="shape-table"></div>
                </div>
              </div>
              <div id="shape-dialog-copywrite-info" class="small"></div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

    `

    //document.getElementById('custom-shape').onclick = (() => this.onShapeFileClick('custom-shape'))
    //document.getElementById('custom-aluminum-stringer-shapes').onclick = (() => this.onShapeFileClick('custom-aluminum-stringer-shapes'))
    //document.getElementById('custom-soldier-shapes').onclick = (() => this.onShapeFileClick('custom-soldier-shapes'))
  }
}

customElements.define('shape-selector-component', ShapeSelectorComponent)

function onNorthAmericanSteelClick() {
  const button = document.getElementById('north-american-shapes-button')
  toggleShapeButtons(button)
  button.dispatchEvent(new CustomEvent('north-american-steel-shapes-selected'))
}

function onEuropeanSteelClick() {
  const button = document.getElementById('european-shapes-button')
  toggleShapeButtons(button)
  button.dispatchEvent(new CustomEvent('european-steel-shapes-selected'))
}

function onWoodShapesClick() {
  const button = document.getElementById('wood-shapes-button')
  toggleShapeButtons(button)
  button.dispatchEvent(new CustomEvent('wood-shapes-selected'))
}

function onCustomShapesClick() {
  const button = document.getElementById('custom-shapes-button')
  toggleShapeButtons(button)
  button.dispatchEvent(new CustomEvent('custom-shapes-selected'))
}

function toggleShapeButtons(button) {
  document.getElementById('north-american-shapes-button').classList.remove('btn-primary')
  document.getElementById('north-american-shapes-button').classList.add('btn-default')
  document.getElementById('european-shapes-button').classList.remove('btn-primary')
  document.getElementById('european-shapes-button').classList.add('btn-default')
  document.getElementById('wood-shapes-button').classList.remove('btn-primary')
  document.getElementById('wood-shapes-button').classList.add('btn-default')
  document.getElementById('custom-shapes-button').classList.remove('btn-primary')
  document.getElementById('custom-shapes-button').classList.add('btn-default')
  button.classList.add('btn-primary')
}

